import type FileSystemItem from 'devextreme/file_management/file_system_item';
import { isHeicPath } from '../mediaViewer/heicConversion';
import { getMediaKind } from '../mediaViewer/mediaFileTypes';
import { parseItemPathForRoutes, type MountRoute } from './createFileBrowserProvider';
import { previewFileUrl } from './fileBrowserApi';

/** DevExtreme FileManager thumbnail URLs for grid view and the details thumbnail column. */
export function customizeFileBrowserThumbnail(
  item: FileSystemItem,
  routes: readonly MountRoute[]
): string {
  if (item.isDirectory) return '';

  const parsed = parseItemPathForRoutes(item, routes);
  if (!parsed?.relative) return '';

  if (getMediaKind(item.name) === 'image' && !isHeicPath(item.name)) {
    return previewFileUrl(parsed.mount.id, parsed.relative);
  }

  return '';
}
